import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faRotate, faWarning } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { translationKeys } from "../../../models/app-translation-keys";
import { ActionButton } from "../../Shared/Buttons/ActionButton/ActionButton";

import "./GlobalErrorBoundary.scss";

export const GlobalErrorFallback: FunctionComponent = () => {
  const { t } = useTranslation();

  const handleReload = (): void => {
    window.location.reload();
  };

  const handleGoHome = (): void => {
    window.location.href = "/";
  };

  return (
    <div className="error-boundary">
      <div className="content">
        <span className="icon">
          <FontAwesomeIcon icon={faWarning} size="5x" color="warning" />
        </span>

        <h1 className="title">{t(translationKeys.globalErrorBoundary.title)}</h1>

        <p className="subtitle">{t(translationKeys.globalErrorBoundary.subtitleText)}</p>

        <div className="actions">
          <ActionButton
            id="global-error-fallback-reload-button"
            label={t(translationKeys.globalErrorBoundary.actions.reloadPage)}
            icon={faRotate}
            onClick={handleReload}
          />

          <ActionButton
            id="global-error-fallback-go-home-button"
            label={t(translationKeys.globalErrorBoundary.actions.goToHome)}
            onClick={handleGoHome}
            hideBackground
          />
        </div>
      </div>
    </div>
  );
};
